import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { renderRichText } from '@storyblok/vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Wysiwyg',
  props: { blok: Object },
  setup(__props) {

const props = __props;


const articleContent = computed(() => renderRichText(props.blok!.text))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { innerHTML: _unref(articleContent) }, null, 8, _hoisted_1))
}
}

})